import { render, staticRenderFns } from "./list-information.vue?vue&type=template&id=227df476&scoped=true"
import script from "./list-information.vue?vue&type=script&lang=js"
export * from "./list-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227df476",
  null
  
)

export default component.exports